import { css } from '@emotion/react';
import {
  useCallback, useState,
} from 'react';
import {
  InputSize, InputWithSpinnersComponent,
} from '~/_shared/baseComponents/inputs';
import { isNullsy } from '~/_shared/utils/typeGuards';

const numericInput = css({
  width: 120,
  flex: 'initial',
});

type ConstraintSliderInputProps = {
  max?: number;
  min?: number;
  value: number;
  onChange: (value: number) => void;
};

export const ConstraintSliderInput = ({
  value,
  onChange,
  min,
  max,
}: ConstraintSliderInputProps) => {
  const [tempValue, setTempValue] = useState<number | null>(null);

  const propagateChange = useCallback(() => {
    if (isNullsy(tempValue)) {
      return;
    }

    onChange(Number(tempValue));
    setTempValue(null);
  }, [onChange, tempValue]);

  return (
    <InputWithSpinnersComponent
      hideSpinners
      useLocaleFormat
      onChange={setTempValue}
      onBlur={propagateChange}
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          propagateChange();
        }
      }}
      valueMin={min}
      valueMax={max}
      value={tempValue ?? value}
      css={numericInput}
      size={InputSize.Small}
    />
  );
};
